/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationCredentials
 */
export interface IntegrationCredentials {
    /**
     * 
     * @type {string}
     * @memberof IntegrationCredentials
     */
    readonly facility_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCredentials
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCredentials
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCredentials
     */
    integration_type: IntegrationCredentialsIntegrationTypeEnum;
}


/**
 * @export
 */
export const IntegrationCredentialsIntegrationTypeEnum = {
    Aida: 'aida',
    Aidin: 'aidin',
    Ensocare: 'ensocare',
    EnsocareVa: 'ensocare_va',
    Repisodic: 'repisodic',
    EpicCareLink: 'epic_care_link',
    EpicCareLinkAlbanyMed: 'epic_care_link_albany_med',
    EpicCareLinkAllinaHealth: 'epic_care_link_allina_health',
    EpicCareLinkAsante: 'epic_care_link_asante',
    EpicCareLinkAscension: 'epic_care_link_ascension',
    EpicCareLinkAspirusHealth: 'epic_care_link_aspirus_health',
    EpicCareLinkAtriumHealth: 'epic_care_link_atrium_health',
    EpicCareLinkBsaHospital: 'epic_care_link_bsa_hospital',
    EpicCareLinkBaptistHealth: 'epic_care_link_baptist_health',
    EpicCareLinkBenefisHealthSystem: 'epic_care_link_benefis_health_system',
    EpicCareLinkBaylorScottWhiteHealth: 'epic_care_link_baylor_scott_white_health',
    EpicCareLinkBryanHealth: 'epic_care_link_bryan_health',
    EpicCareLinkBonSecoursMercyHealth: 'epic_care_link_bon_secours_mercy_health',
    EpicCareLinkBostonMedicalCenter: 'epic_care_link_boston_medical_center',
    EpicCareLinkBronsonHealthcare: 'epic_care_link_bronson_healthcare',
    EpicCareLinkCapeCodHealthcare: 'epic_care_link_cape_cod_healthcare',
    EpicCareLinkCaromont: 'epic_care_link_caromont',
    EpicCareLinkCarolinaEast: 'epic_care_link_carolina_east',
    EpicCareLinkErlanger: 'epic_care_link_erlanger',
    EpicCareLinkCentraCare: 'epic_care_link_centra_care',
    EpicCareLinkChristusHealth: 'epic_care_link_christus_health',
    EpicCareLinkConeHealth: 'epic_care_link_cone_health',
    EpicCareLinkCovenantHealthcare: 'epic_care_link_covenant_healthcare',
    EpicCareLinkDeaconess: 'epic_care_link_deaconess',
    EpicCareLinkDenverHealth: 'epic_care_link_denver_health',
    EpicCareLinkDukeHealth: 'epic_care_link_duke_health',
    EpicCareLinkEcuHealth: 'epic_care_link_ecu_health',
    EpicCareLinkElCaminoHealth: 'epic_care_link_el_camino_health',
    EpicCareLinkEnloeHealth: 'epic_care_link_enloe_health',
    EpicCareLinkFirstHealth: 'epic_care_link_first_health',
    EpicCareLinkGenesisHealthcareSystem: 'epic_care_link_genesis_healthcare_system',
    EpicCareLinkParkview: 'epic_care_link_parkview',
    EpicCareLinkFmolhsCareConnect: 'epic_care_link_fmolhs_care_connect',
    EpicCareLinkSelectMedical: 'epic_care_link_select_medical',
    EpicCareLinkHartfordHealthcare: 'epic_care_link_hartford_healthcare',
    EpicCareLinkHackensackMeridianHealth: 'epic_care_link_hackensack_meridian_health',
    EpicCareLinkHealthPartners: 'epic_care_link_health_partners',
    EpicCareLinkHealtheConnection: 'epic_care_link_healthe_connection',
    EpicCareLinkHennepin: 'epic_care_link_hennepin',
    EpicCareLinkHillcrestHealthcare: 'epic_care_link_hillcrest_healthcare',
    EpicCareLinkHospitalSistersHealthSystem: 'epic_care_link_hospital_sisters_health_system',
    EpicCareLinkHurleyMedicalCenter: 'epic_care_link_hurley_medical_center',
    EpicCareLinkIowaHealthCare: 'epic_care_link_iowa_health_care',
    EpicCareLinkIntegrisHealth: 'epic_care_link_integris_health',
    EpicCareLinkJupiterMedicalCenter: 'epic_care_link_jupiter_medical_center',
    EpicCareLinkKaiserPermanente: 'epic_care_link_kaiser_permanente',
    EpicCareLinkKingsDaughters: 'epic_care_link_kings_daughters',
    EpicCareLinkLegacyHealthyPlanet: 'epic_care_link_legacy_healthy_planet',
    EpicCareLinkMHealthFairview: 'epic_care_link_m_health_fairview',
    EpicCareLinkMainLineHealth: 'epic_care_link_main_line_health',
    EpicCareLinkMayoClinic: 'epic_care_link_mayo_clinic',
    EpicCareLinkMercy: 'epic_care_link_mercy',
    EpicCareLinkMethodistHospitals: 'epic_care_link_methodist_hospitals',
    EpicCareLinkMethodistHealthSystem: 'epic_care_link_methodist_health_system',
    EpicCareLinkMiddlesexHealth: 'epic_care_link_middlesex_health',
    EpicCareLinkMyMichiganHealth: 'epic_care_link_my_michigan_health',
    EpicCareLinkNortonHealthcare: 'epic_care_link_norton_healthcare',
    EpicCareLinkNorthMemorialHealth: 'epic_care_link_north_memorial_health',
    EpicCareLinkOhioHealth: 'epic_care_link_ohio_health',
    EpicCareLinkOklahomaHeartHospital: 'epic_care_link_oklahoma_heart_hospital',
    EpicCareLinkOsfHealthcare: 'epic_care_link_osf_healthcare',
    EpicCareLinkOwensboroHealth: 'epic_care_link_owensboro_health',
    EpicCareLinkPiedmont: 'epic_care_link_piedmont',
    EpicCareLinkProvidence: 'epic_care_link_providence',
    EpicCareLinkSaintFrancis: 'epic_care_link_saint_francis',
    EpicCareLinkShannonHealth: 'epic_care_link_shannon_health',
    EpicCareLinkSsmHealth: 'epic_care_link_ssm_health',
    EpicCareLinkStElizabethHealthcare: 'epic_care_link_st_elizabeth_healthcare',
    EpicCareLinkStormontVailHealth: 'epic_care_link_stormont_vail_health',
    EpicCareLinkTexasHealth: 'epic_care_link_texas_health',
    EpicCareLinkTheQueensHealthSystem: 'epic_care_link_the_queens_health_system',
    EpicCareLinkThedacare: 'epic_care_link_thedacare',
    EpicCareLinkTrihealth: 'epic_care_link_trihealth',
    EpicCareLinkTrinityHealth: 'epic_care_link_trinity_health',
    EpicCareLinkUcHealth: 'epic_care_link_uc_health',
    EpicCareLinkUconnHealth: 'epic_care_link_uconn_health',
    EpicCareLinkUnityPointHealth: 'epic_care_link_unity_point_health',
    EpicCareLinkUniversityOfCincinnati: 'epic_care_link_university_of_cincinnati',
    EpicCareLinkUniversityOfKansas: 'epic_care_link_university_of_kansas',
    EpicCareLinkUmms: 'epic_care_link_umms',
    EpicCareLinkUniversityHealth: 'epic_care_link_university_health',
    EpicCareLinkUniversityOfUtah: 'epic_care_link_university_of_utah',
    EpicCareLinkUpmcPinnacle: 'epic_care_link_upmc_pinnacle',
    EpicCareLinkSouthShoreHealth: 'epic_care_link_south_shore_health',
    EpicCareLinkStLukes: 'epic_care_link_st_lukes',
    EpicCareLinkPremierHealth: 'epic_care_link_premier_health',
    EpicCareLinkUncHealth: 'epic_care_link_unc_health',
    EpicCareLinkUtHealthEastTexas: 'epic_care_link_ut_health_east_texas',
    EpicCareLinkUtSouthwestern: 'epic_care_link_ut_southwestern',
    EpicCareLinkVitruvianHealth: 'epic_care_link_vitruvian_health',
    EpicCareLinkWellstar: 'epic_care_link_wellstar',
    EpicCareLinkKetteringHealth: 'epic_care_link_kettering_health',
    EpicCareLinkOmc: 'epic_care_link_omc',
    EpicCareLinkFranciscanHealth: 'epic_care_link_franciscan_health',
    EpicCareLinkMvhs: 'epic_care_link_mvhs',
    EpicCareLinkGeisinger: 'epic_care_link_geisinger',
    Fax: 'fax',
    ManualUpload: 'manual_upload',
    ManualCopy: 'manual_copy',
    Pcc: 'pcc',
    MatrixCare: 'matrix_care',
    WellskyIntake: 'wellsky_intake',
    WellskyIntakeCareportQuickcase: 'wellsky_intake_careport_quickcase',
    WellskyCareportReferralIntake: 'wellsky_careport_referral_intake',
    WellskyReferralManagement: 'wellsky_referral_management',
    WellskyReferralManagementWebReferral: 'wellsky_referral_management_web_referral',
    FourNext: 'four_next'
} as const;
export type IntegrationCredentialsIntegrationTypeEnum = typeof IntegrationCredentialsIntegrationTypeEnum[keyof typeof IntegrationCredentialsIntegrationTypeEnum];


/**
 * Check if a given object implements the IntegrationCredentials interface.
 */
export function instanceOfIntegrationCredentials(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "integration_type" in value;

    return isInstance;
}

export function IntegrationCredentialsFromJSON(json: any): IntegrationCredentials {
    return IntegrationCredentialsFromJSONTyped(json, false);
}

export function IntegrationCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationCredentials {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'username': json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'integration_type': json['integration_type'],
    };
}

export function IntegrationCredentialsToJSON(value?: IntegrationCredentials | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
        'integration_type': value.integration_type,
    };
}

